import { getUser } from '~src/user';

export const initProductFruits = async () => {
  const { user } = await getUser();

  window.$productFruits.push([
    'init',
    process.env.PRODUCTFRUITS_WORKSPACE_CODE,
    'it',
    {
      username: user.username,
      email: user.email,
      firstname: user.first_name,
      lastname: user.last_name,
      signUpAt: new Date(user.createdAt).toISOString(), // format of signUpAt is: yyyy-mm-ddThh:mm:ssZ
      role: user.ruolo,
      props: {
        orgId: user.org_pointer.objectId,
        orgName: user.org_pointer.nome,
        tipo_istanza: user.org_pointer.tipo_istanza,
        tipo_licenza: user.org_pointer.tipo_licenza,
        plan: user.org_pointer.plan,
      },
    },
    {
      hideInAppCenterLauncher: true,
    },
  ]);
};
